import axios from "axios";

const api = axios.create({
  // baseURL: "http://localhost:8080/api",
  baseURL: "https://pressmanager-backend.onrender.com/api",
});

// ✅ REQUEST INTERCEPTOR
api.interceptors.request.use(config => {

  const token = localStorage.getItem("accessToken");

  if (token && !config.url.includes("/auth/")) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});


// ✅ RESPONSE INTERCEPTOR
api.interceptors.response.use(
  response => response,
  async error => {

    const originalRequest = error.config;

    // ❌ If login/register/refresh fails → don't try refresh
    if (originalRequest.url.includes("/auth/")) {
      return Promise.reject(error);
    }

    // ✅ Only handle 401 once
    if (error.response?.status === 401 && !originalRequest._retry) {

      originalRequest._retry = true;

      const refreshToken =
        localStorage.getItem("refreshToken");

      if (!refreshToken) {
        localStorage.clear();
        window.location.href = "/";
        return Promise.reject(error);
      }

      try {

        const res = await api.post("/auth/refresh", {
          refreshToken
        });

        const newAccess =
          res.data.data.accessToken;

        localStorage.setItem("accessToken", newAccess);

        originalRequest.headers.Authorization =
          `Bearer ${newAccess}`;

        return api(originalRequest);

      } catch (refreshError) {

        localStorage.clear();
        window.location.href = "/";
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default api;